module.exports = __webpack_public_path__ + "static/ks-fbeca0c08ae73f389b789414169c5dfb.png";